/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
export const palette = {
  emerald: {
    main: "#009874",
    light: "#1EC79F",
    dark: "#007055",
  },
  sapphire: {
    main: "#0091FF",
    light: "#54B5FF",
    dark: "#016FC2",
  },
  text: {
    primary: "#43484D",
    secondary: "#5E6977",
    disabled: "#B5BECA",
    highlight: "#f44336",
    alert: "#C10C0D",
    expandedMenu: "#FFFFFF",
  },
  border: {
    main: "#cccccc",
    hover: "#F0F4F7",
    alert: "#C10C0D",
  },
  divider: {
    dark: "#4C5256",
  },
  background: {
    default: "#F4F4F4",
    paper: "#FFFFFF",
    transparency: "CC",
  },
  disabled: {
    background: "#F0F4F7",
  },
  info: {
    main: "#0288D1",
    light: "#99C2E1",
    dark: "#01579B",
    contrastText: "#FFFFFF",
  },
};
